import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core'
import { Router } from '@angular/router'

import { Subscription } from 'rxjs/Subscription'

import { AuthService } from '../../auth/auth.service'

import { NotificationService } from '../shared/notification.service'
import { Notification } from '../shared/notification.model'

import { DialogService } from '../../dialog/shared/dialog.service'
import { AudioService } from '../../shared/shared.module'

@Component({
  selector: 'cm-notification-factory',
  templateUrl: './notification-factory.component.html',
  styleUrls: ['./notification-factory.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationFactoryComponent implements OnInit, AfterViewInit, OnDestroy {

  notification: Notification

  private subscription: Subscription

  constructor(private notificationService: NotificationService,
    private dialogService: DialogService,
    private audioService: AudioService,
    private cdRef: ChangeDetectorRef,
    private router: Router) { }

  ngOnInit() {
    // this.notificationService.requestPermission()

    this.subscription = this.notificationService.getNotificationEmitter()
      .subscribe((notification: Notification) => {
        this.notification = notification

        this.audioService.playSound('../../../assets/sounds/notification.wav')

        this.cdRef.markForCheck()
      })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.notificationService.showPermissionDialog()
    }, 3000)
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  // add(notification: Notification) {
  //   this.notifications.push(notification)
  //   this.cdRef.markForCheck()
  // }

  goto(conversationId: string) {
    this.router.navigate(['/chatroom', conversationId])
    this.notification = null
    // this.notifications.pop()
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/notification/notification-factory/notification-factory.component.ts